export default function () {
    const widgetName = 'staticPartnersWidget';
    const widgetOpts = staticPartnersWidgetOpts;
  
    return saffire.widgets.cardWidget($(`#${widgetName}`), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      cardWidgetLoaded: function (slide) {
  
      },
      itemsPerPanel: 1,
      hasImages: true,
      lazyLoadImages: true,
      imageIsBackground: true,
      link: ['all'], // [], ['all'], ['image', 'title', 'description']
      maxItemsVisible: 8,
  
      scriptPath: widgetOpts.scriptPath,
      showDescription: false,
      textOverImage: false
    });
  }